import { Routes, Route } from 'react-router-dom';
import NotFoundPage from '../pages/not-found/not-found-page';
import { LoadingScreen } from '@bemap/ui';
import { RoleLevel, useRouteGuard } from '@bemap/utils';
import ProtectedRoutes from './protected-routes';
import PublicRoutes from './public-routes';
import { FC } from 'react';

const App: FC = () => {
  const { isAuthenticated, user, isLoading } = useRouteGuard();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated && user?.permission === RoleLevel.ADMIN) {
    return (
      <Routes>
        <Route path="/*" element={<ProtectedRoutes user={user} />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/*" element={<PublicRoutes />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default App; 